import {
  IUpdate_Dayuse_Filter,
  UPDATE_DAY_USE_FILTER,
  IToggle_Dayuse_Loading,
  TOGGLE_DAY_USE_LOADING,
  IFetch_Dayuse_Srp_Data,
  FETCH_DAY_USE_SRP_DATA,
  IUpdate_Dayuse_Srp_Seo_Data,
  UPDATE_DAY_USE_SRP_SEO_DATA,
  IUpdateDayUseSeoFlags,
  IUpdate_Dayuse_SEO_Flags,
  UPDATE_DAY_USE_SEO_FLAGS,
  UPDATE_DAY_USE_SRP_CONFIG,
  IUpdate_Dayuse_Srp_Config,
  IUPDATE_Dayuse_EXPANDED_STICKY_FILTER,
  UPDATE_DAY_USE_EXPANDED_STICKY_FILTER,
  RESET_DAY_USE_SRP_HOTEL_LIST,
  IReset_Day_Use_Srp_Hotel_List,
  RESET_DAY_USE_FILTER,
  IReset_Dayuse_Filter,
  UPDATE_DAY_USE_SORT_FILTER_CLOSE_FLAG,
  IUpdate_Day_Use_SRP_SORT_FILTER_CLOSE_Flags,
  IUpdateDayuseSRPSortFilterFlags,
  IFlush_Dayuse_Srp_Data,
  FLUSH_DAY_USE_SRP_DATA,
  RESET_DAY_USE_SRP,
  IReset_Dayuse_Srp,
  // FETCH_SRP_DATA,
  // IUpdate_Filter,
  // IUpdate_Srp_Config,
  // UPDATE_SRP_CONFIG,
  // IFetch_Srp_Data,
  // IToggle_Loading,
  // TOGGLE_LOADING,
  // RESET_FILTER,
  // RESET_SRP,
  // RESET_SRP_HOTEL_LIST,
  // IReset_Filter,
  // IReset_Srp,
  // IRegionCity,
  // IUpdate_SEO_Flags,
  // IUpdate_Region_City,
  // IUpdate_Srp_Offer_Data,
  // IUpdate_Srp_Offer_Loading,
  // UPDATE_SRP_OFFER_DATA,
  // UPDATE_SEO_FLAGS,
  // UPDATE_EXPANDED_STICKY_FILTER,
  // UPDATE_REGION_CITY,
  // IUpdateSeoFlags,
  // IUpdate_Srp_Seo_Data,
  // UPDATE_SRP_SEO_DATA,
  // IFlush_Srp_Data,
  // FLUSH_SRP_DATA,
  // SET_SELECTED_HOTEL_ITEM,
  // selectedHotelItemData,
  // IUpdateMetaSRPFlags,
  // UPDATE_META_SRP_FLAGS,
  // IUpdate_META_SRP_Flags,
  // IUpdate_HAS_GOSUGGEST_DATA_Flags,
  // IUpdateHasGoSuggestSRPDataFlags,
  // IUpdateCRMSRPFlags,
  // UPDATE_CRM_SRP_FLAGS,
  // IUpdate_CRM_SRP_Flags,
  // IUpdateSemSRPFlags,
  // IUpdate_SEM_SRP_Flags,
  // UPDATE_SEM_SRP_FLAGS,
  // UPDATE_HAS_GO_SUGGEST_SRP_DATA_FLAGS,
  // IUPDATE_EXPANDED_STICKY_FILTER,
  // UPDATE_SRP_OFFER_LOADING,
  // UPDATE_SORT_FILTER_CLOSE_FLAG,
  // IUpdate_SRP_SORT_FILTER_CLOSE_Flags,
  // IUpdateSRPFSortFilterFlags,
  // IUpdateSRPNextWithNoEndFlag,
  // UPDATE_NEXT_WITH_NO_END_FLAG,
  // IUpdate_SRP_NEXT_WITH_NO_END_Flags,
} from './types';

export function updateDayUseSrpConfigAction(
  actionData: IUpdate_Dayuse_Srp_Config['actionData'],
): IUpdate_Dayuse_Srp_Config {
  return {
    type: UPDATE_DAY_USE_SRP_CONFIG,
    actionData,
  };
}

export function fetchDayUseSrpDataAction(
  actionData: IFetch_Dayuse_Srp_Data['actionData'],
  loadingMore?: boolean,
  isNextWithNoEndAndNoData?: boolean,
): IFetch_Dayuse_Srp_Data {
  return {
    type: FETCH_DAY_USE_SRP_DATA,
    actionData,
    loadingMore,
    isNextWithNoEndAndNoData,
  };
}

export function updateDayUseFilterAction(
  actionData: IUpdate_Dayuse_Filter['actionData'],
): IUpdate_Dayuse_Filter {
  return {
    type: UPDATE_DAY_USE_FILTER,
    actionData,
  };
}

export function toggleDayUseIsLoadingAction({
  isLoading,
  displayOverlay,
}: {
  isLoading: IToggle_Dayuse_Loading['isLoading'];
  displayOverlay: IToggle_Dayuse_Loading['displayOverlay'];
}): IToggle_Dayuse_Loading {
  return {
    type: TOGGLE_DAY_USE_LOADING,
    isLoading,
    displayOverlay,
  };
}

export function updateDayUseSrpSeoData(
  actionData: IUpdate_Dayuse_Srp_Seo_Data['actionData'],
): IUpdate_Dayuse_Srp_Seo_Data {
  return {
    type: UPDATE_DAY_USE_SRP_SEO_DATA,
    actionData,
  };
}

export function updateDayUseSeoFlags(actionData: IUpdateDayUseSeoFlags): IUpdate_Dayuse_SEO_Flags {
  return {
    type: UPDATE_DAY_USE_SEO_FLAGS,
    actionData,
  };
}

export function updateDayUseCurrentExpandedFilter(
  actionData: string,
): IUPDATE_Dayuse_EXPANDED_STICKY_FILTER {
  return {
    type: UPDATE_DAY_USE_EXPANDED_STICKY_FILTER,
    actionData,
  };
}

export function resetDayUseSrpHotelList(): IReset_Day_Use_Srp_Hotel_List {
  return {
    type: RESET_DAY_USE_SRP_HOTEL_LIST,
  };
}

export function resetDayuseFilterAction(): IReset_Dayuse_Filter {
  return {
    type: RESET_DAY_USE_FILTER,
  };
}

export function updateDayuseSRPSortFilterClose(
  actionData: IUpdateDayuseSRPSortFilterFlags,
): IUpdate_Day_Use_SRP_SORT_FILTER_CLOSE_Flags {
  return {
    type: UPDATE_DAY_USE_SORT_FILTER_CLOSE_FLAG,
    actionData,
  };
}

export function resetDayuseSrpAction(): IReset_Dayuse_Srp {
  return {
    type: RESET_DAY_USE_SRP,
  };
}

export function flushDayuseSrpDataAction(): IFlush_Dayuse_Srp_Data {
  return {
    type: FLUSH_DAY_USE_SRP_DATA,
  };
}
